import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Grid,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import configServ from "../../services/config";
import { toast, Toaster } from "react-hot-toast";
import SchedulesTable from "./SchedulesTable";
import CircularProgress from "@mui/material/CircularProgress";
import { LoadingButton } from "@mui/lab";
const SchedulesCard = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [practitionersName, setPractitionersName] = useState([]);
  const [ScheduleData, setScheduleData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingg, setLoadingg] = useState(false);

  const [error, setError] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const fiveYearsLater = new Date();
  fiveYearsLater.setFullYear(fiveYearsLater.getFullYear() + 5);

  const [formData, setFormData] = useState({
    doctor_id: "",
    day_of_week: isEdit ? [] : "",
    start_time: "",
    end_time: "",
    slot_duration: "",
    start_date: today,
    end_date: fiveYearsLater.toISOString().split("T")[0],
    is_active: false,
    online: false,
  });

  const handleClickOpen = () => {
    setOpenDialog(!openDialog);
    clearForm();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    // console.log("Checkbox changed:", name, checked);
    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: checked,
      };
      // console.log("Updated state will be:", updated);
      return updated;
    });
  };

  useEffect(() => {
    const fetchPractitionersName = async () => {
      try {
        const res = await configServ.getAllPractitioners();
        if (res.success) setPractitionersName(res?.data);
      } catch (err) {
        setError("Failed to fetch practitionar  name");
        console.error(err);
      }
    };

    fetchPractitionersName();
  }, []);

  const fetchDoctarShedule = async () => {
    setLoading(true);
    try {
      const res = await configServ.getAllSchedulesWithDoctorInfo();
      if (res.success) setScheduleData(res?.data);
    } catch (err) {
      setError("Failed to fetch practitionar  name");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDoctarShedule();
  }, []);

  const formatTime = (timeStr) => timeStr?.slice(0, 5); // ensures only HH:mm

  const handleSubmit = async () => {
    if (!formData.doctor_id) {
      toast.error("Please select a doctor.");
      return;
    }

    if (!formData.day_of_week || formData.day_of_week.length === 0) {
      toast.error("Please select at least one day of the week.");
      return;
    }

    if (!formData.start_time || !formData.end_time) {
      toast.error("Please select both start and end time.");
      return;
    }

    if (formData.end_time <= formData.start_time) {
      toast.error("End time must be after start time.");
      return;
    }

    if (!formData.slot_duration || Number(formData.slot_duration) <= 0) {
      toast.error("Please enter a valid slot duration.");
      return;
    }

    if (!formData.start_date || !formData.end_date) {
      toast.error("Please select both start and end dates.");
      return;
    }

    if (formData.end_date < formData.start_date) {
      toast.error("End date cannot be earlier than start date.");
      return;
    }
    // console.log("formdata",formData)

    const dataToSend = {
      ...formData,
      start_time: formatTime(formData.start_time),
      end_time: formatTime(formData.end_time),
      day_of_week: isEdit
        ? formData.day_of_week // string
        : formData.day_of_week, // array
    };
    // console.log("dataToSend====",dataToSend)
    try {
      setLoadingg(true);
      let res;
      if (isEdit) {
        res = await configServ.updateDoctorScheduleViaPost(dataToSend);
      } else {
        res = await configServ.storeDoctorSchedule(dataToSend);
      }

      if (res.success) {
        toast.success(
          isEdit
            ? "Schedule updated successfully"
            : "Schedule created successfully"
        );
        clearForm(); // optional: clear after submit
        setOpenDialog(false); // optional: close dialog after submit
        fetchDoctarShedule();
      } else if (res.success === false) {
        toast.error(res.message);
      } else {
        toast.error(res.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error submitting schedule:", error);
      toast.error("Failed to submit schedule");
    } finally {
      setLoadingg(false);
    }
  };

  const clearForm = () => {
    setFormData({
      doctor_id: "",
      day_of_week: [],
      start_time: "",
      end_time: "",
      slot_duration: "",
      is_active: false,
      start_date: today,
      end_date: fiveYearsLater.toISOString().split("T")[0],
      online: false,
    });
    setIsEdit(false);
  };

  const handleEditData = (rowData) => {
    console.log("handleEditData", rowData);
    scrollToTop();
    setIsEdit(true);
    setOpenDialog(true);
    setFormData({
      doctor_id: rowData.doctor_id || "",
      day_of_week: rowData.day_of_week || "", // string for edit
      start_time: rowData.start_time || "",
      end_time: rowData.end_time || "",
      slot_duration: rowData.slot_duration || "",
      is_active: rowData.is_active === 1 || rowData.is_active === true,
      online: rowData.online === 1 || rowData.online === true,
      id: rowData.id || "",
      start_date: rowData.start_date,
      end_date: rowData.end_date,
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    console.log("Form Data Updated:", formData);
  }, [formData]);

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Create Schedules"}
        handlePopup={handleClickOpen}
        create={openDialog}
      />
      {openDialog && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            marginTop: 0,
            padding: 20,
            borderRadius: "10px",
            border: "none",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "16px", fontWeight: "bolder" }}>
                Doctor Schedule
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Doctor</InputLabel>
                <Select
                  name="doctor_id"
                  value={formData.doctor_id}
                  onChange={handleChange}
                  sx={{ backgroundColor: "white" }}
                >
                  {practitionersName.map((doc) => (
                    <MenuItem key={doc.id} value={doc.id}>
                      {doc.fname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Day(s) of Week</InputLabel>
                <Select
                  name="day_of_week"
                  multiple={!isEdit} // 👈 Allow multiple only if not editing
                  value={formData.day_of_week}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      day_of_week: value, // no array wrapping
                    }));
                  }}
                  sx={{ backgroundColor: "white" }}
                  renderValue={(selected) =>
                    Array.isArray(selected) ? selected.join(", ") : selected
                  }
                >
                  {[
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ].map((day) => (
                    <MenuItem key={day} value={day}>
                      {!isEdit && (
                        <Checkbox
                          checked={formData.day_of_week.includes(day)}
                        />
                      )}
                      {day}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Start Time"
                name="start_time"
                type="time"
                inputProps={{
                  step: 300, // 5 min steps
                  pattern: "[0-9]{2}:[0-9]{2}", // 24-hour pattern
                }}
                value={formData.start_time}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                label="End Time"
                name="end_time"
                type="time"
                inputProps={{
                  step: 300,
                  pattern: "[0-9]{2}:[0-9]{2}",
                }}
                value={formData.end_time}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Slot Duration (in minutes)"
                name="slot_duration"
                type="number"
                value={formData.slot_duration}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Start Date"
                name="start_date"
                type="date"
                value={formData.start_date}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                label="End Date"
                name="end_date"
                type="date"
                value={formData.end_date}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: formData.start_date }} // ⛔ prevents selecting a past date
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.is_active}
                    onChange={handleCheckboxChange}
                    name="is_active"
                  />
                }
                label="Is Active"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.online}
                    onChange={handleCheckboxChange}
                    name="online"
                  />
                }
                label="Online Doctor"
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              spacing={2}
              justifyContent="flex-end"
              sx={{ mt: 1 }}
            >
              <Grid item xs={12} sm={6} md={2}>
                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={clearForm}
                  startIcon={<RotateLeftIcon />}
                >
                  Reset
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <LoadingButton
                  fullWidth
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  loading={loadingg}
                  startIcon={<SaveIcon />}
                >
                  {isEdit ? "Update" : "Save"}
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </motion.div>
      )}

      <SchedulesTable
        ScheduleData={ScheduleData}
        loading={loading}
        handleEditData={handleEditData}
      />
    </>
  );
};

export default SchedulesCard;
